import styled from 'styled-components'

export const CanvasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`
